export interface ElementWithOffset extends Element {
    offsetHeight: number;
}

export default function calculateStreamSize() {
    const vbHeaderElement: ElementWithOffset | null = document.querySelector(
        '.header'
    );

    const vbNavbarElement: ElementWithOffset | null = document.querySelector(
        '.nav-bar'
    );

    const fixedFooterElement: ElementWithOffset | null = document.querySelector(
        '.__app-fixed-footer-container'
    );

    const vbHeaderHeight = vbHeaderElement ? vbHeaderElement.offsetHeight : 0;
    const vbNavbarHeight = vbNavbarElement ? vbNavbarElement.offsetHeight : 0;

    const fixedFooterHeight = fixedFooterElement
        ? fixedFooterElement.offsetHeight
        : 0;

    const marginSize = 22; // margins of CMS header and bottom menu are included when using offsetHeight. So we add it later.
    const headerPaddingSize = 20; // padding of Vb header and menu

    const streamHeight =
        window.innerHeight -
        vbHeaderHeight -
        vbNavbarHeight -
        fixedFooterHeight +
        marginSize;

    const paddingTop = vbHeaderHeight - headerPaddingSize;

    return {
        streamHeight,
        paddingTop,
    };
}
